import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useRouteSortingStore, SortingOption } from "../../../stores/routeSortingStore";
import { Popover, PopoverContent, PopoverTrigger } from "../../../components/shadcn/popover";
import { Tooltip, TooltipContent, TooltipTrigger } from "../../../components/shadcn/tooltip";
import clsx from "clsx";
import { ArrowUpDown } from "lucide-react";
import CheckIcon from "../../../components/Icons/CheckIcon";
import InfoIcon from "../../../components/Icons/InfoIcon";
const sortingOptions = [
    {
        value: SortingOption.RELEVANCE,
        label: 'Relevance',
        showInfo: true,
        infoText: 'Sorted by balance for "from" direction, by usage history and rank for "to" direction'
    },
    {
        value: SortingOption.MOST_USED,
        label: 'Most Used'
    },
    {
        value: SortingOption.TRENDING,
        label: 'Trending'
    },
    {
        value: SortingOption.ALPHABETICAL_ASC,
        label: 'Alphabetical A-Z'
    },
    {
        value: SortingOption.ALPHABETICAL_DESC,
        label: 'Alphabetical Z-A'
    }
];
const RouteSortingMenu = () => {
    const [open, setOpen] = useState(false);
    const sortingOption = useRouteSortingStore((s) => s.sortingOption);
    const setSortingOption = useRouteSortingStore((s) => s.setSortingOption);
    const handleSelect = (option) => {
        setSortingOption(option);
        setOpen(false);
    };
    return (_jsxs(Popover, { open: open, onOpenChange: setOpen, children: [_jsx(PopoverTrigger, { asChild: true, children: _jsx("button", { type: "button", className: "flex items-center justify-center rounded-lg p-1 hover:bg-secondary-400 transition-colors", "aria-label": "Sort options", children: _jsx(ArrowUpDown, { className: "w-4 h-4 text-primary-text-tertiary hover:text-primary-text transition-colors" }) }) }), _jsx(PopoverContent, { className: "min-w-[170px] p-0 bg-secondary-500! rounded-xl", align: "start", sideOffset: 8, children: _jsx("div", { className: " flex flex-col gap-1", children: sortingOptions.map((option) => (_jsxs("button", { type: "button", onClick: () => handleSelect(option.value), className: clsx("w-full px-1.5 py-0.5 text-sm text-left flex items-center justify-between hover:bg-secondary-300 transition-colors rounded-lg", {
                            "bg-secondary-300": sortingOption === option.value
                        }), children: [_jsxs("span", { className: "flex items-center gap-2", children: [_jsx("span", { className: clsx("text-secondary-text font-normal", {
                                            "text-primary-text": sortingOption === option.value
                                        }), children: option.label }), option.showInfo && (_jsxs(Tooltip, { children: [_jsx(TooltipTrigger, { type: "button", onClick: (e) => {
                                                    e.stopPropagation();
                                                }, className: "flex items-center", children: _jsx("span", { children: _jsx(InfoIcon, { className: "w-3.5 h-3.5 text-primary-text-tertiary hover:text-primary-text transition-colors" }) }) }), _jsx(TooltipContent, { side: "right", className: "max-w-[240px] text-xs", children: _jsx("p", { children: option.infoText }) })] }))] }), sortingOption === option.value && (_jsx(CheckIcon, { className: "w-4 h-4 text-primary-text shrink-0" }))] }, option.value))) }) })] }));
};
export default RouteSortingMenu;
